// extracted by mini-css-extract-plugin
export default {"fadeSlideUp":"fadeSlideUp--pUnjQ"};